document.addEventListener("DOMContentLoaded", () => {
	const buttons = document.querySelectorAll(".js-youtube-open");
	const modal = document.getElementById("youtubeModal");
	const frame = document.getElementById("youtubeFrame");
	const closeBtns = document.querySelectorAll(".js-youtube-close");

	buttons.forEach((btn) => {
		btn.addEventListener("click", () => {
			const id = btn.dataset.youtube;
			frame.src = `https://www.youtube.com/embed/${id}?autoplay=1&rel=0`;
			modal.classList.add("is-active");
			modal.setAttribute("aria-hidden", "false");
		});
	});

	closeBtns.forEach((btn) => {
		btn.addEventListener("click", () => {
			modal.classList.remove("is-active");
			modal.setAttribute("aria-hidden", "true");
			frame.src = "";
		});
	});
});
